import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useEditPermission = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [editLoading, setEditLoading] = useState(false);

  const editRequest = (payload, getPermissionList, setIsEditModalOpen) => {
    setEditLoading(true);
    axiosClient
      .put(`SettingAccount/Permission/Update`, payload)
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`ویرایش با موفقیت انجام شد`, { variant: 'success' });
          getPermissionList();
          setIsEditModalOpen(false);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setEditLoading(false));
  };
  return [editRequest, editLoading];
};

export default useEditPermission;
